import { Capacitor } from "@capacitor/core";

/** Keep native runtime checks in one place so browser/PWA behavior remains unchanged. */
export const isNativeApp = (): boolean => Capacitor.isNativePlatform();
export const nativePlatform = (): string => Capacitor.getPlatform();
